import {
  FormControl,
  RadioGroup,
  RadioGroupProps,
  FormControlLabel,
  Radio,
  FormLabel,
  useTheme,
} from '@mui/material';

import { colors } from 'config/theme';
import { Option } from 'types/Form';

import { StyledFormHelperText } from './styledComponents';
interface RadioButtonRowProps extends RadioGroupProps {
  options?: Array<Option>;
  checkedValue?: string | number | undefined;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
}
export const RadioButtonRow = (props: RadioButtonRowProps) => {
  const {
    title,
    options,
    children,
    sx,
    checkedValue,
    id,
    helperText,
    error,
    disabled,
    ...rest
  } = props;
  const theme = useTheme();
  return (
    <FormControl fullWidth sx={sx}>
      {title && (
        <FormLabel color={error ? 'error' : 'primary'} id={id}>
          {title}
        </FormLabel>
      )}
      {helperText && (
        <StyledFormHelperText error>{helperText}</StyledFormHelperText>
      )}
      <RadioGroup name={title} aria-labelledby={id} {...rest}>
        {options
          ? options.map((option) => (
              <FormControlLabel
                disabled={disabled}
                checked={option.value === checkedValue}
                key={`${option.label}-${option.value}`}
                value={option.value}
                label={option.label}
                control={
                  <Radio
                    sx={{
                      color: error
                        ? colors.uswds.redCool50
                        : theme.palette.grey[700],
                    }}
                  />
                }
              />
            ))
          : children}
      </RadioGroup>
    </FormControl>
  );
};
